import React from 'react'
import { ParsedPricingInfo, PricingPeriodType } from 'utils/apiUtils/prices'
import PriceInfo from './PriceInfo'
import { Box, Flex, Separator, Text } from '@chakra-ui/react'
import { removeDecimals } from 'utils/removeDecimals'
import { useTranslation } from 'react-i18next'

type Props = {
  pricingInfo: ParsedPricingInfo
}
const PeriodInfoContent = ({ pricingInfo }: Props) => {
  const { t } = useTranslation('common')
  const pricingPeriods = pricingInfo.periodsInfo

  const hourlyPeriod = pricingPeriods.find((s) => s.type === PricingPeriodType.HOURLY)
  const dailyPeriod = pricingPeriods?.find((s) => s.type === PricingPeriodType.DAILY)
  const weeklyPeriod = pricingPeriods?.find((s) => s.type === PricingPeriodType.WEEKLY)
  return (
    <Box>
      {hourlyPeriod && <PriceInfo info={hourlyPeriod} pricingPeriods={pricingPeriods} />}
      {dailyPeriod && <PriceInfo info={dailyPeriod} pricingPeriods={pricingPeriods} />}
      {weeklyPeriod && <PriceInfo info={weeklyPeriod} pricingPeriods={pricingPeriods} />}

      {pricingInfo.handlingFee && (
        <>
          <Separator />

          <Box marginTop={10}>
            <Flex direction="row" justifyContent="space-between" alignItems="center" marginBottom={5}>
              <Box>
                <Text as="span" fontWeight="semibold" lineHeight="normal">
                  {t('reservationFee')}
                </Text>
                <Text fontSize="sm">{t('pricingInfoDescription.appliedOnlyOnce')}</Text>
              </Box>
              <Box textAlign="right">
                <Text fontWeight="bold" fontSize={{ base: 'md', lg: 'xl' }} lineHeight="normal">
                  {removeDecimals(pricingInfo.handlingFee)} {t('nok')}
                </Text>
              </Box>
            </Flex>
          </Box>
        </>
      )}
    </Box>
  )
}

export default PeriodInfoContent
